var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLocker = function SvgIconLocker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5314 0C8.95845 0 5.23802 3.69114 5.23802 8.22812V13.165H3.57933C1.7498 13.165 0.261963 14.6411 0.261963 16.4562V29.6212C0.261963 31.4364 1.7498 32.9125 3.57933 32.9125H23.4836C25.3131 32.9125 26.8009 31.4364 26.8009 29.6212V16.4562C26.8009 14.6411 25.3131 13.165 23.4836 13.165H21.8249V8.22812C21.8249 3.69114 18.1044 0 13.5314 0ZM23.4836 16.4562L23.4869 29.6212H3.57933V16.4562H23.4836ZM8.55539 13.165V8.22812C8.55539 5.50626 10.788 3.29125 13.5314 3.29125C16.2749 3.29125 18.5075 5.50626 18.5075 8.22812V13.165H8.55539Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLocker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-locker.db0f34e2.svg";
export { ForwardRef as ReactComponent };